export const FETCH_CHART_DATA = '/play/fetch';
export const SAVE_CHART_DATA = '/play/save';
export const GET_METRICS_DATA = '/metrics/get';
export const GET_MASTER_COLUMN_DATA = '/masterdata/fetchColumnData';
export const GET_DIMENSIONS_DATA = '/dimensionMetaData/get/objects';
export const GET_EXCEPTION_RULES_DATA = '/exceptionrule/get/all';
export const GET_MASTER_DATA = '/masterdata/fetch';
export const FETCH_EXCEPTION_RULES = '/exceptionrule/get/all';
export const FETCH_EXCEPTION_SINGLE_RULE = '/exceptionrule/get';
export const FETCH_EXCEPTION_RULE_PROPERTIES = '/dimensionMetaData/get/properties';
export const FETCH_EXCEPTION_CREATE_RULE = '/exceptionrule/create';
export const FETCH_EXCEPTION_UPDATE_RULE = '/exceptionrule/update';
export const FETCH_EXCEPTION_RUN_RULE = '/exceptionrule/run';
export const GET_EXCEPTION_ALERT_INSTANCES = '/exceptionalertinstance/get/all';
export const GET_EXCEPTION_ALERT_INSTANCE_DETAILS = '/exceptionalertinstance/get';
export const FETCH_ALL_EXCEPTION_ALERTS = '/exceptionalert/get/all';
export const FETCH_EXCEPTION_ALERT = '/exceptionalert/get';
export const GET_SINGLE_DASHBOARD_DATA = '/dashboard/fetch';
export const GET_ALL_DASHBOARD_DATA = '/dashboard/fetchAll';
export const GET_SINGLE_CARD_DATA = '/card/fetch';
export const DELETE_DASHBOARD = '/dashboard/delete';
export const SET_STARRED_DASHBOARD = '/dashboard/setStarred';
export const EDIT_DASHBOARD_DATA = '/dashboard/edit';
export const FETCH_EXCEPTION_CREATE_DEFINITION_ALERT = '/exceptionalert/create';
export const UPDATE_EXCEPTION_CREATE_DEFINITION_ALERT = '/exceptionalert/update';
export const DELETE_EXCEPTION_CREATE_DEFINITION_ALERT = '/exceptionalert/disable';
export const FETCH_ACCOUNT_DETAILS = '/user/fetch/details';
export const FETCH_SSL_CERTIFICATE_DETAILS = '/download-hanlder/ssl-certificate';
export const UPDATE_ACCOUNT_DETAILS = '/user/edit/details';
export const SET_HOME_PAGE = '/user/setUserLandingPage';
export const CHANGE_PASSWORD = '/user/password/change';
export const GET_CSS_FILE_NAME = '/ssr/filename';
export const GET_THEME = '/ssr/theme';
export const REQUEST_LOGIN = '/join/login';
export const REQUEST_LOGOUT = '/user/logout';
export const GET_EMAIL_ADDRESS = '/join/password/forgot';
export const FETCH_LOGO_AND_ID = '/orgconfig/fetchOrganisationDetails';
export const INVITE_USER = '/user/invite';
export const DELETE_INVITE = '/user/deleteInvite';
export const DOWNLOAD_USERS = '/team/relation/users/download';


export const GET_USER_PERMISSIONS = '/user/permissions/fetchAll';
export const USER_PERMISSIONS_DATA = '/team/relation/users';
export const GET_USER_PERMISSION_DETAILS = '/user/details?id=';
export const UPDATE_USER_PERMISSIONS = '/user/edit/';
export const EDIT_USER_WITH_TEAM = '/team/relation/users';

export const GENERATE_API_KEY = '/user/generate/api_key';

export const PASSWORD_RESET_SUBMIT = '/join/password/reset/submit/';
export const SUBMIT_SIGNUP = '/join/submit/signup/';
export const FETCH_ALL_USERS_OF_CURRENT_ORGANISATION = '/team/relation/users';
export const FETCH_ALL_USERS_BY_ORGANISATION_V2 = '/user/fetch/usersByOrganisation';
export const FETCH_ALL_USERS_BY_ORGANISATION_V3 = '/user';
export const FETCH_ALL_USERS_BY_ORGANISATION = '/user/fetchByOrganisation';
export const UPDATE_SHIPMENT_DOCUMENTS = '/shipment/documents';
export const CT_CUSTOM_FIELDS = '/organisation-custom-fields';
export const CHANGE_USER_STATUS = '/user/change/status';
export const UPDATE_FINANCING_CTA_STATUS = '/user/updateFinancingCtaStatus';
export const GET_TRACKING_REQUESTS = '/tracking-request/fetch';
export const SEND_SHIPMENT_DUMP = '/shipment/dump/send';
export const SEND_CONTAINER_DUMP = '/container/dump/send';
export const SE_LINK_BL_TO_CONTAINER = '/execution/link-bl-number';
export const SHIPMENT_TENDER_MANUAL = '/container/manual/send-vessel-sailed-mail'
export const GET_MULTIPLE_POLLING_BL_REQUESTS = '/tracking-request/poll';
export const SHIPMENT_TRACKING_CONTAINER_POLL = '/container/poll';
export const GET_GLOBAL_CONTAINERS_COUNT = '/tracking-request/global/container-count';
export const GET_PORTS = '/port/get';
export const GET_LOAD_PORTS = '/loadport/get';
export const GET_DISCHARGE_PORTS = '/dischargeport/get';
export const GET_BL_LIST = '/shipment/search';
export const CREATE_IMPORTS = '/imports/create';
export const BULK_IMPORTS_STATUS_UPDATE = '/imports/status/update-bulk';
export const CREATE_EXPORTS = '/exports/create';
export const CREATE_MULTIPLE_EXPORTS = '/exports/createMultiple';
export const CREATE_MULTIPLE_IMPORTS = '/imports/createMultiple';
export const EDIT_MULTIPLE_IMPORTS = '/imports/edit-bulk';
export const FETCH_IMPORTS = '/imports/fetch';
export const DELETE_IMPORTS = '/imports/delete';
export const FETCH_IMPORTS_MASTERDATA = '/imports/fetch/master';
export const DOWNLOAD_IMPORTS = '/imports/download';
export const FETCH_EXPORTS = '/exports/fetch';
export const DOWNLOAD_EXPORTS = '/exports/download';
export const EDIT_IMPORTS = '/imports/edit';
export const DOWNLOAD_SAMPLE_IMPORTS = '/imports/download/sample/shipments';
export const DOWNLOAD_SAMPLE_IMPORTS_STATUS_FILE = '/imports/download/sample/status';
export const DOWNLOAD_SAMPLE_EDIT_IMPORTS_FILE = '/imports/download/sample/shipments/edit';
export const EDIT_EXPORTS = '/exports/edit';
export const SEARCH_IMPORTS_BY_VESSEL = '/imports/fetchByVessel';
export const FETCH_IMPORTS_INSIGHTS_DASHBOARD = '/imports/fetchinsightsdashboard';
export const UPDATE_IMPORT_STATUS = '/imports/status/update';
export const UPDATE_EXPORT_STATUS = '/exports/status/update';
export const FETCH_IMPORT_DETAILS = '/imports/fetchDetailed';
export const FETCH_EXPORT_DETAILS = '/exports/fetchDetailed';
export const SHIPMENT_QUICK_ADD = '/shipment';
export const SHIPMENT_QUICK_ADD_BULK = '/shipment/create/bulk';
export const SHIPMENT_ADD_BULK_VALIDATE = '/shipment/create/validate-bulk'
export const DISABLE_CONTAINER = '/tracking-request';
export const DISABLE_CONTAINER_BY_CONTAINER = '/shipment';
export const ADD_SUBSCRIBER_CONTAINER = '/shipment/subscribers';
export const ADD_SUBSCRIBER_CONTAINER_BULK = '/shipment/subscribers/bulk';
export const ADD_SUBSCRIBER_CONTAINER_CN = '/container/share';
export const ADD_SUBSCRIBER_CONTAINER_BULK_CN = '/container/share/bulk';
export const GET_CONTAINER_DETAILS = '/tracking-request/details';
export const DOWNLOAD_CONTAINER_TRACKING = '/tracking-request/download';
export const DOWNLOAD_CONTAINER_TRACKING_CONTAINER = '/container/download';
export const FETCH_PERMISSIONS = '/permissions/getAll';
export const COPY_PERMISSIONS = '/permissions/copy';
export const FETCH_SINGLE_PERMISSIONS = '/permissions/fetch';
export const CREATE_NEW_PERMISSION = '/permissions/create';
export const EDIT_PERMISSION = '/permissions/edit';
export const FETCH_LTL_TRACKING = '/ltl/track/shipments/fetch';
export const CREATE_LTL_TRACKING = '/ltl/track/shipments/create';
export const EDIT_LTL_SHIPMENT = '/ltl/track/shipments/edit';
export const DELETE_LTL_SAVED_ADDRESS = '/ltl/address/delete';
export const EDIT_LTL_ADDRESS = '/ltl/address/edit';
export const CREATE_LTL_ADDRESS = '/ltl/address/create';
export const FETCH_LTL_ADDRESS = '/ltl/address/fetch';
export const FETCH_LTL_DETAILS = '/ltl/track/shipments/fetchDetailed';
export const POLL_LTL_TRACKING = '/ltl/track/shipments/status/fetch';
export const DELETE_LTL = '';
export const FETCH_LTL_MULTIPLE_UPLOAD = '/ltl/track/shipments/createMultiple';
export const SEARCH_CUSTOMER_LTL = '/ltl/track/searchCustomer';
export const FETCH_LTL_SUMMARY_METRICS = '/ltl/summaryMetrics/fetch';
export const FETCH_LTL_SUMMARY_METRICS_DATA = '/ltl/summaryMetrics/calculate';
export const GET_RFQ_LIST = '/rfq/plan/fetchV2';
export const CREATE_RFQ_PLAN = '/rfq/plan/createv2';
export const DOWNLOAD_LTL_TRACKING = '/ltl/track/download/create';
export const GET_DOWNLOAD_REQUESTS = '/ltl/track/download/get ';
export const CREATE_SALES_ORDER = '/exim/salesorder/create';
export const ASSIGN_CHA_TO_SO = '/exim/salesorder/cha/assign';
export const ASSIGN_FF_TO_SO = '/exim/salesorder/ff/assign';
export const ASSIGN_SHIPPING_LINE_TO_SO = '/exim/salesorder/shippingline/assign ';
export const EDIT_SALES_ORDER = '/exim/salesorder/edit';
export const CREATE_MULTIPLE_SALES_ORDER = '/exim/salesorder/createBulk';
export const FETCH_SALES_ORDERS = '/exim/salesorder/fetch/all';
export const FETCH_SALER_ORDER_DETAILS = '/exim/salesorder/details';
export const ADD_EDIT_SALES_ORDER_BOOKING_DETAILS = '/exim/salesorder/booking/create';
export const ADD_EDIT_SALES_ORDER_PAYMENT_DETAILS = '/exim/salesorder/payment/create';
export const FETCH_DO_LIST_FROM_SO = '/exim/deliveryorder/getDOList';
export const CREATE_DO_SO = '/exim/deliveryorder/create';
export const EDIT_DO_SO = '/exim/deliveryorder/edit';
export const DO_CONTAINER_ADD = '/exim/deliveryorder/container/add';
export const CUSTOMS_CLEARANCE_SO = '/exim/salesorder/customsClearance';
export const APPROVE_DRAFT_BL_SO = '/exim/salesorder/draftApproved';
export const CREATE_DOCUMENT_SO = '/exim/document/create';
export const GET_S3_UPLOAD_LINKS = '/exim/upload/s3/uploadlinks';
export const RAKE_SEARCH = '/exim/rake/search';
export const GET_DO_LIST = '/exim/deliveryorder/getDOList';
export const EDIT_SO_CONTAINER = '/exim/salesorder/container/edit';
export const CREATE_SO_CONTAINER = '/exim/salesorder/container/create';
export const RFQ_FETCH_RANKED_BIDS = '/rfq/lineItem/fetch/rankedBidsV2';
export const FETCH_RFQ_DETAILS = '/rfq/plan/fetch/detailedV2';
export const EDIT_REFERENCE_RATE_RFQ = '/rfq/lineItem/referenceRate/editV2';
export const EDIT_STATUS_RFQ = '/rfq/lineItem/status/updateV2';
export const EDIT_STATUS_RFQ_AMENDED = '/rfq/plan/amended-rfq/status/update';
export const FINALISE_QUOTE_NEXT = '/rfq/quote/finalise';
export const MY_RFQ_APPROVALS = '/rfq/quote/my-approvals';
// Legacy RFQ module My-Approvals feed (ISS-289524). Merged with MY_RFQ_APPROVALS into one RFQ tab.
export const MY_LEGACY_RFQ_APPROVALS = '/rfq/lineItem/my-approvals';
export const SEND_RFQ = '/rfq/plan/sendRFQV2';
export const REJECT_BID = '/rfq/bid/rejectV2';
export const ADD_LINE_ITEM_RFQ = '/rfq/plan/lineItem/addV2';
export const RFQ_DETAIL_BID_LINE_ITEM = '/rfq/bid/fetch/allV2';
export const RFQ_RATE_MASTERS = '/masterdata/rfq/rate-master/fetch';
export const RFQ_RATE_MASTERS_DOWNLOAD = '/masterdata/rfq/rate-master/download/excel';
export const FETCH_RAKE = '/exim/rake/fetch/all';
export const BULK_CREATE_RAKE = '/exim/rake/createBulk';
export const EDIT_RAKE = '/exim/rake/edit';
export const FETCH_RAKE_DETAILS = '/exim/rake/details';
export const SEARCH_SO = '/exim/salesorder/search';
export const LINK_SO_TO_RAKE = '/exim/salesorder/linkToRakeBulk';
export const UPDATE_RAKE_STATUS = '/exim/rake/updateStatus';
export const DOWNLOAD_RAKE_SUMMARY = '/exim/rake/summary/download';
export const SELECT_BID_LINE_ITEM = '/rfq/bid/setV2';
export const BID_DETAILS = '/rfq/bid/fetch/detailedV2';
export const BIDDING_DETAILS = '/rfq/shippingLine/plan/fetch/detailedV2';
export const BIDDING_DETAILS_FF = BIDDING_DETAILS;
export const BIDDING_DATES = '/rfq/shippingLine/plan/getDatesV2';
export const BIDDING_DATES_FF = BIDDING_DATES;
export const ADD_BID = '/rfq/bid/shippingLine/bid/addV2';
export const ADD_BID_FF = ADD_BID;
export const SEND_RESPONSE = '/rfq/shippingLine/rfqEntity/response/sendV2';
export const SEND_RESPONSE_FF = SEND_RESPONSE;
export const SEND_ACCPET_EXCEPTION = '/rfq/shippingLine/rfqEntity/exceptions/accept';
export const DOWNLOAD_EXCEPTION = '/rfq/shippingLine/rfqEntity/download/exceptions';
export const GET_BIDDING_LIST = '/rfq/shippingLine/plan/fetchV2';
export const APPROVE_TNC = '/rfq/shippingLine/plan/sendResponseToTermsAndConditionsV2';
export const GET_BIDDING_LIST_FF = GET_BIDDING_LIST;
export const BIDDING_SAVED_QUOTE = '/rfq/savedQuote/getV2';
export const BIDDING_LAST_QUOTE = '/rfq/sentQuote/getV2';
export const FETCH_LINE_ITEM_ACTIVITY = '/rfq/lineItem/activity/fetchV2';
export const FETCH_BID_ACTIVITY = '/rfq/bid/activity/fetchV2';
export const FINALISE_SELECTED_BID = '/rfq/bid/finalizeV2';
export const BIDDING_ACTIVITY = '/rfq/shippingLine/rfqEntity/activity/fetchV2';
export const BIDDING_ACTIVITY_FF = BIDDING_ACTIVITY;
export const ADD_LINE_ITEM = '/rfq/plan/lineItem/addV2';
export const RFQ_BID_COMPARISON = '/rfq/bid/compareV2';
export const STUFF_CONTAINERS = '/exim/salesorder/container/stuff';
export const RFQ_BID_PREFILLED_DATA_DOWNLOAD =
  '/rfq/shippingLine/bid/prefilled/bid/data/downloadV2';
export const RFQ_BID_REVOKE_PREFILLED_DATA_DOWNLOAD =
  '/rfq/shippingLine/bid/delete/prefilled/download';
export const RFQ_BID_PREFILLED_DATA_DOWNLOAD_FF = RFQ_BID_PREFILLED_DATA_DOWNLOAD;
export const RFQ_UPLOAD_BID_EXCEL = '/rfq/bid/upload/excelV2';
export const RFQ_BULK_REVOKE_EXCEL = '/rfq/bid/bulk/delete';
export const RFQ_SINGLE_REVOKE_SAVED = ({ rfqId, bidId }) => `/rfq/${rfqId}/bids/${bidId}`;
export const RFQ_UPLOAD_BID_EXCEL_FF = RFQ_UPLOAD_BID_EXCEL;
export const RFQ_DOWNLOAD_LINE_ITEM_EXCEL = '/rfq/plan/lineItem/download/excelV2';
export const RFQ_BULK_EDIT_DOWNLOAD = '/rfq/plan/lineItem/bulk-edit/download';
export const RFQ_DOWNLOAD_LINE_ITEM_BIDS_EXCEL = '/rfq/bid/downloadV2';
export const RFQ_DOWNLOAD_BIDS_RANKING = '/rfq/bid/download/rankedBidsV2';
export const GET_ALL_PORTS = '/port/fetchAll';
export const RFQ_DOWNLOAD_SAMPLE_LINE_ITEMS = '/rfq/lineItem/download/prefilled/excelV2';
export const EDIT_LINE_ITEM_RFQ = '/rfq/lineItem/editv2';
export const BULK_EDIT_LINE_ITEM_RFQ = '/rfq/plan/lineItem/bulk-edit/upload';
export const BULK_ADD_LINE_ITEM_RFQ = '/rfq/plan/lineItem/bulk-add/upload';
export const DELETE_LINE_ITEM_RFQ = '/rfq/lineItem/delete';
export const EDIT_RFQ_PLAN = '/rfq/plan/editV2';
export const DELETE_RFQ_PLAN = '/rfq/plan/delete';
export const FETCH_PREVIOUS_BID_DATA = '/rfq/shippingLine/plan/fetchPreviousBidDetailsV2';
export const DOWNLOAD_TNC_RFQ_SHIPPER = '/rfq/plan/tnc/downloadV2';
export const DOWNLOAD_TNC_RFQ_SHIPPING_LINE = '/rfq/shippingLine/plan/tnc/downloadV2';
export const DOWNLOAD_SUMMARY_SHEET_RFQ = '/rfq/bid/download/summarySheetV2';
export const RFQ = '/rfq';
export const RFQ_BIDS = '/bids';
export const RFQ_MIS_REPORTS = '/rfq/plan/getReports';
export const RFQ_FRC_REPORT = '/rfq/plan/reports/freight-circular';
export const RFQ_ACTIVE_RFQ_NAMES = '/rfq/plan/get/active-rfq-plans';
export const RFQ_MASTER_CHARGES = '/rfq/plan/getEditableChargesMaster';
export const RFQ_FETCH_POL_LIST_FOR_LINE_ITEMS = (rfqPlanId) =>
  `/rfq/plan/${rfqPlanId}/lineItems/originPorts`;
export const RFQ_DELETE_SENT_BID = '/rfq/bid/bulk/delete';
export const RFQ_DELETE_SAVED_BID = (rfqPlanId) =>
  `${RFQ_SHIPPINGLINE_PLAN}/${rfqPlanId}${RFQ_BIDS}`;

export const RFQ_BID_CHARGES = '/rfq/shipping-line/charge-master/fetch/editable/charges';
export const RFQ_ALL_BID_CHARGES = '/rfq/shipping-line/charge-master/fetch/all';

export const RFQ_DASHBOARD_SUMMARY = '/rfq/plan/summary';
export const RFQ_SHIPPINGLINE_DASHBOARD_SUMMARY = '/rfq/shippingLine/plan/summary';

export const RFQ_WITHDRAW_AMENDMENT = '/rfq/plan/line/item/amendment/withdraw';

export const RFQ_BID_HISTORY = (bidId: string) => `/rfq/bid/${bidId}/history`;
export const RFQ_EDIT_CONTRACT = '/rfq/shippingLine/bid/contractNumber';

export const CARRIER_MANAGEMENT_ADD_CARRIER_PARTNER =
  '/ltl/courierPartnerManagement/courierPartner/add';
export const CARRIER_MANAGEMENT_FETCH_CARRIER_PARTNERS =
  '/ltl/courierPartnerManagement/courierPartner/fetch';
export const CARRIER_MANAGEMENT_UPDATE_STATUS =
  '/ltl/courierPartnerManagement/courierPartner/updateStatus';
export const CARRIER_MANAGEMENT_FETCH_SERVICE_TYPES = '/ltl/serviceTypes/fetch';
export const CARRIER_MANAGEMENT_ADD_SERVICE_TYPE = '/ltl/serviceTypes/add';
export const RFQ_UPDATE_ROUND = '/rfq/plan/round/updateV2';
export const EXTEND_DEADLINE_RFQ = '/rfq/plan/deadline/updateV2';
export const RFQ_DOWNLOAD_EXCEPTION_REPORT = '/rfq/plan/exception/downloadV2';
export const RFQ_DOWNLOAD_IMPACT_ANALYSIS_REPORT = '/rfq/plan/impactReport/downloadV2';
export const RFQ_DOWNLOAD_AMENDMENT_REPORT = '/rfq/lineItem/download/amendmentReport';
export const RFQ_DEADLINE_UPDATE = '/rfq/deadline/updateV2';

export const GET_CONTAINER_DETAILS_UUID = '/p/bl_detail';
export const GET_REFRESH_BL_TRACKING = '/tracking-request/refresh';
export const GET_REFRESH_CONTAINER_TRACKING = '/container/refresh';
export const GET_SHIPMENT_STATUSWISE_COUNT = '/shipment/status';
export const POST_CONTAINER_RESET = '/container/reset'

export const RFQ_DOWNLOAD_SAP_FILE = '/rfq/bid/download/sap/v2';
export const RFQ_UPLOAD_BULK_AMENDMENT = '/rfq/plan/line/item/amendment';
export const RFQ_REGION_LINE_ITEMS = '/rfq/plan/line-item-template/fetch';
export const RFQ_REGION_DOWNLOAD_SAMPLE_LINE_ITEM = '/rfq/plan/line-item-template/sample/download';
export const RFQ_REGION_DOWNLOAD_LINE_ITEM = '/rfq/plan/line-item-template/download';
export const RFQ_REGION_ADD_LINE_ITEM = '/rfq/plan/line-item-template/add';
export const RFQ_REGION_EDIT_LINE_ITEM = '/rfq/plan/line-item-template/edit';

export const CALCULATE_WEIGHTED_AVERAGE = '/rfq/plan/weighted-average';
export const RFQ_COMPILED_REPORTS = '/rfq/plan/reports/compiled';
export const RFQ_FLEXIBLE_REPORTS_MASTER_DATA= '/rfq/plan/flexible-reports/masterdata';
export const RFQ_FLEXIBLE_REPORTS_EXCEL= '/rfq/plan/flexible-reports/download';
export const RFQ_FLEXIBLE_REPORTS_HISTORY= '/rfq/plan/flexible-reports/draft';
export const RFQ_NEW_UPDATES = '/rfq/plan/updates';
export const RFQ_BIDS_TREND = '/rfq/plan/bid-trend';
export const RFQ_COUNTRY_CODE = '/country/search';
export const RFQ_DOWNLOAD_INDIVIDUAL_RATES = '/rfq/plan/lineitem/download/individual-reference-rate/excel';
export const RFQ_UPLOAD_INDIVIDUAL_RATES = '/rfq/plan/lineitem/upload/individual-reference-rate/excel';
export const RFQ_ALLOW_MULTIPLE_RATES = '/rfq/lineItem/allow-multiple-contract-rates';
export const RFQ_PRODUCT_MASTER = '/product/search';
export const RFQ_GROUP_ID = '/rfq/plan/group-id';

/** RFQ Terms & Conditions */
export const RFQ_GET_TNC_MASTER = '/rfq-tnc-master/fetch';
export const RFQ_GET_DEFAULT_TNC = '/rfq-tnc-master/default/fetch';
export const RFQ_DOWNLOAD_TNC_EXCEL = '/rfq-tnc-master/download';
export const RFQ_UPDATE_TNC_MASTER = '/rfq-tnc-master/edit';
export const RFQ_DELETE_TNC_MASTER = '/rfq-tnc-master/delete';
export const RFQ_ADD_ONE_TNC = '/rfq-tnc-master/add';
export const RFQ_UPLOAD_TNC_EXCEL = '/rfq-tnc-master/add/bulk';
export const RFQ_DOWNLOAD_TNC_SAMPLE_EXECEL = '/rfq-tnc-master/sample-excel/download';
export const RFQ_UPLOAD_TNC_DOCUMENT = '/rfq-tnc-master/document/upload';
export const RFQ_DELETE_TNC_DOCUMENT = '/rfq-tnc-master/document/delete';
export const RFQ_DOWNLOAD_VOLUME_SHEET = '/rfq/lineItem/volume-sheet';
export const RFQ_DOWNLOAD_SAP_RESPONSE_REPORT = '/rfq/plan/sap-response-report';
export const GLOBAL_RANKED_BIDS_REPORT = '/rfq/plan/reports/global-ranking-file';
export const RFQ_DOWNLOAD_ROUND_COMPARISON_REPORT = '/rfq/plan/reports/round-comparison';
/** RFQ Tender */
export const RFQ_TENDER_FORM_FIELDS = '/rfq/tender/form-fields';
export const RFQ_TENDER_CREATE = '/rfq/tender/create';
export const RFQ_TENDER_DETAILS = '/rfq/tender';

/** RFQ Line Item */
export const RFQ_LINE_ITEM_FETCH = '/rfq/line-item';
export const RFQ_LINE_ITEM_FORM_FIELDS = '/rfq/line-item/form-fields';
export const RFQ_LINE_ITEM_CREATE = '/rfq/line-item/create';
export const RFQ_LINE_ITEM_BULK_UPLOAD = '/rfq/line-item/create/upload';
export const RFQ_LINE_ITEM_TEMPLATE = '/rfq/line-item/create/template';
export const RFQ_LINE_ITEM_SEND = '/rfq/line-item/send';
export const RFQ_LINE_ITEM_BULK_SEND = '/rfq/line-item/bulk-send';
export const RFQ_LINE_ITEM_QUOTES_DOWNLOAD = '/rfq/line-item/quotes/download';
export const RFQ_REFERENCE_QUOTE_DOWNLOAD = '/rfq/quote/reference/download';
export const RFQ_TENDER_QUOTES_DOWNLOAD = '/rfq/quote/download';

/** RFQ Quote */
export const RFQ_QUOTE_LIST = '/rfq/quote/list';
export const RFQ_QUOTE_ADD_QUOTE_FIELDS = '/rfq/quote/add-quote-fields';
export const RFQ_QUOTE_ADD_SINGLE_QUOTE = '/rfq/quote/create';
export const RFQ_QUOTE_TEMPLATE_FILE = '/rfq/quote/template-file';
export const RFQ_QUOTE_BULK_CREATE = '/rfq/quote/bulk/create';
export const RFQ_QUOTE_SEND = '/rfq/quote/send';
export const RFQ_QUOTE_BULK_SEND = '/rfq/quote/bulk/send';
export const RFQ_QUOTE_REVOKE = '/rfq/quote/revoke';

/** RFQ Chargemaster */
export const RFQ_GET_CHARGE_MASTER = '/rfq/charge-master/view';
export const RFQ_SEARCH_CHARGE_MASTER = '/rfq/charge-master/search';
export const RFQ_EDIT_CHARGE_MASTER = '/rfq/charge-master/edit';

export const CONTAINER_TRACKING_REQUEST = '/container/fetch';
export const GET_META_DATA = '/containerTracking/summaryDashboard/getMetadata';
export const GET_CHART_DATA = '/containerTracking/summaryDashboard/getChart/';
export const SUMMARY_DASHBOARD_GET_CONTAINERS =
  '/containerTracking/summaryDashboard/getContainerData/click';
export const SUMMARY_DASHBOARD_GET_SHIPMENTS =
  '/containerTracking/summaryDashboard/getShipmentData/click';
export const SUMMARY_DASHBOARD_DOWNLOAD_CONTAINER_DATA =
  '/containerTracking/summaryDashboard/downloadContainerData/excel';
export const SUMMARY_DASHBOARD_DOWNLOAD_SHIPMENT_DATA =
  '/containerTracking/summaryDashboard/downloadShipmentData/excel';
export const SUMMARY_DASHBOARD_CUSTOMER_SEARCH = '/customer/searchCustomers';
export const CUSTOMER_FETCH_ALL_DATA = '/customer/fetchAll';
export const CREATE_STAKEHOLDER = '/stakeholder';
export const FETCH_USER_FROM_TEAM = '/team/relation/users/';
export const MASTERS_FETCH_ALL_DATA = '/master/fetchAll';
export const MASTERS_ADD_NEW = '/customer/add';
export const MASTERS_SEARCH_ORGANISATION = '/master/searchOrganisation';
export const MASTERS_APPROVE_REQUEST = '/master/approve';
export const MASTERS_DISAPPROVE_REQUEST = '/master/disapprove';
export const MASTERS_EDIT = '/customer/edit';
export const MASTERS_FETCH_COUNT_FOR_MASTER_VIEW = '/master/fetchCountForMasterView';
export const TOGGLE_FREIGHT_MODE = '/master/modeOfService/toggle';
export const ENABLE_MODE_OF_SERVICE = '/master/modeOfService/enable';
export const MASTER_FETCH_ALL_STAKEHOLDERS = '/stakeholder';
export const MASTER_FETCH_ALL_STAKEHOLDERS_PAGINATED = '/stakeholder/paginated';
export const EDIT_STAKEHOLDER = '/stakeholder';
export const DELETE_STAKEHOLDER = '/stakeholder';
export const SEARCH_STAKEHOLDER = '/stakeholder/search';
export const STAKEHOLDER_BULK_UPLOAD = '/stakeholder/create/bulk/by-excel';
export const STAKEHOLDER_BULK_UPDATE = '/stakeholder/update/bulk/by-excel';
export const STAKEHOLDER_BULK_SAMPLE_DOWNLOAD = '/stakeholder/bulk/download/sample';
export const STAKEHOLDER_DOWNLOAD_RESULTS = '/stakeholder/download-results-excel';
export const STAKEHOLDER_ADD_VENDOR = '/stakeholder/vendor';
export const STAKEHOLDER_INITIATE_ONBOARDING = '/stakeholder/initiate-onboarding';
export const STAKEHOLDER_RESEND_VENDOR_INVITATION = '/stakeholder/resend-vendor-invitation';
export const STAKEHOLDER_DELETE_VENDOR_INVITATION = '/stakeholder/vendor-invitation';
export const STAKEHOLDER_VENDOR_ACTION_LOGS = '/stakeholder/vendor';
export const STAKEHOLDER_CHILD_BASE = '/stakeholder/child';

export const CHANGE_CONNECTION_STATUS = '/master/connection/change-status';
export const FETCH_KYC_DATA = '/kyc/data/fetch';
export const SEND_CONNECTION_REQUEST = '/master/connection/send-request';
// RFQ Bulk Request
export const RFQ_BULK_REQUEST = '/background-jobs/bulk-download/fetch';
export const RFQ_BULK_REQUEST_SUMMARY = '/background-jobs/fetch';
export const RFQ_BULK_REQUEST_ACTIONS = '/background-jobs/bulk-action/fetch';
export const BACKGROUND_JOBS_STATUS_POLL = '/background-jobs/status/polling';
// Inquiry
export const INQUIRY_GET_EXCHANAGE_RATE = '/inquiry/bid/getExchangeRateFromInquiry';
export const INQUIRY_UPDATE_EXCHANGE_RATE = '/inquiry/updateExchangeRate';
export const INQUIRY_CREATE_INQUERY = '/inquiry/createInquiry';
export const INQUIRY_UPDATE_INQUERY = '/inquiry/editInquiry';
export const INQUIRY_SEARCH_INQUIRY_FOR_FF = '/inquiry/searchInquiryForFF';
export const INQUIRY_SEARCH_INQUIRY_FOR_SHIPPER = '/inquiry/searchInquiryForShipper';
export const INQUIRY_SEND_INQUIRY = '/inquiry/sendInquiry';
export const SEND_BULK_INQUIRY = '/inquiry/sendBulkInquiry';
export const INQUIRY_GET_BID_RANKS_FOR_SHIPPER = '/inquiry/getBidRanksForShipper';
export const INQUIRY_GET_BID_RANKS_FOR_FF = '/inquiry/getBidRanksForFF';
export const INQUIRY_UPDATE_DEADLINE = '/inquiry/updateInquiryDeadline';
export const BULK_INQUIRY_DEADLINE_UPDATE = '/inquiry/updateBulkInquiryDeadline';
export const INQUIRY_FETCH_INQUIRY_SHIPPER_DETAILS = '/inquiry/fetchInquiryDetailsForShipper';
export const INQUIRY_FETCH_ALL_FF_INQUIRIES = '/inquiry/fetchAllInquriesForFF';
export const INQUIRY_FETCH_ALL_SHIPPER_INQUIRIES = '/inquiry/fetchAllInquriesForShipper';
export const INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_SHIPPER_INQUIRIES =
  '/inquiry/fetchInquiryStatusWiseCountForShipper';
export const INQUIRY_FETCH_STATUS_WISE_COUNT_FOR_FF_INQUIRIES =
  '/inquiry/fetchInquiryStatusWiseCountForFF';
export const INQUIRY_FETCH_INQUIRY_DETAILS_FOR_FF = '/inquiry/fetchInquiryDetailsForFF';
export const INQUIRY_FETCH_ALL_INQUIRIES = '/inquiry/fetchAllInquires';
export const INQUIRY_FETCH_ALL_BIDS_SHIPPER_INQUIRY = '/inquiry/bid/fetchAllBidsForInquiry';
export const INQUIRY_FETCH_ALL_BIDS_FF_INQUIRY = '/inquiry/bid/fetchAllBidsForFF';
export const INQUIRY_SEND_BID_FOR_INQUIRY = '/inquiry/bid/sendBidForInquiry';
export const INQUIRY_CREATE_BID_FOR_INQUIRY = '/inquiry/bid/createBidForInquiry';
export const INQUIRY_CREATE_BID_SHIPPER = '/inquiry/bid/create/shipper';
export const INQUIRY_CONFIRM_BID_FOR_INQUIRY = '/inquiry/bid/confirmBidForInquiry';
export const INQUIRY_DECLINE_BID_FOR_INQUIRY = '/inquiry/bid/declineBidForInquiry';
export const INQUIRY_DELETE_BID_FOR_SHIPPER = '/inquiry/bid/deleteBidForInquiryByShipper';
export const INQUIRY_UPDATE_BID_FOR_INQUIRY = '/inquiry/bid/updateBidForInquiry';
export const INQUIRY_GET_MASTER_DATA = '/inquiry/getMasterData';
export const INQUIRY_GET_CREATOR_USERS = '/inquiry/creation-users';
export const INQUIRY_GET_CREATOR_ORGS = '/inquiry/creation-orgs';
export const INQUIRY_GET_BID_MASTER_FOR_INQUIRY = '/inquiry/bid/getBidMasterForInquiry';
export const INQUIRY_FETCH_RECENT_INQUIRY_BIDS_FOR_FF = '/inquiry/bid/fetchRecentInquiryBidsForFF';
export const MASTERS_SEARCH_CUSTOMER = '/customer/searchCustomers';
export const INQUIRY_FF_VIEW_BREAKDOWN = '/inquiry/bid/getBidDetailsForFF';
export const INQUIRY_SHIPPER_VIEW_BREAKDOWN = '/inquiry/bid/getBidDetailsForShipper';
export const INQUIRY_DELETE_INQUIRY = '/inquiry/deleteInquiry';
export const INQUIRY_FETCH_BID_CHARGES = '/inquiry/bid/getBidCharges';
export const GET_DROPDOWN_CHARGE_FOR_BIDS = '/inquiry/bid/charges-dropdown';
export const GET_INQUIRY_DETAILS_FOR_BID = '/inquiry/bid/getInquiryDetailsForBid';
export const INQUIRY_DELETE_BID = '/inquiry/bid/deleteBidForInquiryFF';
export const INQUIRY_DOWNLOAD_BIDS_SHIPPER = '/inquiry/bid/downloadBidsForShipper';
export const INQUIRY_EXETEND_DEADLINE_FOR_BID = '/inquiry/bid/updateBidValidityDate';
export const INQUIRY_DOWNLOAD_BIDS_FF = '/inquiry/bid/downloadBidsForFF';
export const MASTERS_DELETE_CUSTOMER = '/customer/delete';
export const FETCH_INQUIRY_SUMMARY_FOR_SHIPPER = '/inquiry/fetchInquirySummaryForShipper';
export const FETCH_BULK_BID_HEADER_MAPPING = '/inquiry/bid/fetchBulkBidHeaderMapping';
export const DOWNLOAD_SAMPLE_BIDS = '/inquiry/bid/sampleBulk/download';
export const INQUIRY_UPLOAD_BULK_BIDS = '/inquiry/bid/bulkUpload';
export const DOWNLOAD_SAMPLE_BIDS_SHIPPER = '/inquiry/bid/sampleBulk/download/shipper';
export const INQUIRY_UPLOAD_BULK_BIDS_SHIPPER = '/inquiry/bid/bulkUpload/shipper';
export const GET_ALL_CHARGES_FOR_BULK_BIDS_UPLOAD = '/inquiry/bid/charges/bulk';
export const INQUIRY_SEARCH_INTERNAL_REFERENCE = '/inquiry/search/internalReferenceNumber';
export const EDIT_ACCESS_INQUIRY_DETAILS = '/inquiry';
export const FETCH_PREVIOUS_INQUIRIES_FOR_RATE_PARAMETERS = '/inquiry/fetch/spot-search-parameters';
export const INQUIRY_CREATE_NEGOTIATION = '/inquiry/negotiation/create';
export const BOOKING_VIEW_BREAKDOWN_DOWNLOAD = '/booking/view-breakdown-pdf';
export const BOOKING_VIEW_PURCHASE_ORDER = '/booking/booking-details-pdf';
export const FETCH_STRATEGIC_FFS = '/master/strategic-ffs';
export const REJECT_INQUIRY_FF = '/inquiry/ff/reject';
export const REJECTED_INQUIRY_FF = '/inquiry/ffs-rejected';
export const FETCH_STRATEGIC_TRUCKERS = '/master/strategic-trucking-agents';
export const PREFILL_TRAILER_LOCATION_DETAILS = '/inquiry/prefill-trailer-location-details';
export const GET_RANK1_PRICE = '/inquiry/bid';

export const SEND_DSR_TRACKING = '/shipment/send/dsr';
export const SEARCH_INTERNAL_NUMBERS_CT = '/shipment/search/internal-ref';
export const DOWNLOAD_SAMPLE_TRACKING = '/shipment/download/sample';
export const EDIT_CT_CONTAINER = '/container';
export const EDIT_CT_SHIPMENT = '/shipment';
export const EDIT_CT_BL = '/tracking-request';
export const SEARCH_SHIPMENT_BY_TYPE = '/shipment/search/number';
export const SEARCH_SHIPMENT_OWNER = '/shipment/get-all-shipment-owners'

export const ADVISORY_FETCH = '/advisory/';

export const INQUIRY_MIS_REPORTS = '/inquiry/fetchInquiryReportsDashboard';

export const INQUIRY_BID_REVISION_SHIPPER = '/inquiry/bid/getrevisionsshipper';
export const INQUIRY_BID_REVISION_FF = '/inquiry/bid/getrevisionsff';

export const INQUIRY_HSN_CODE = '/inquiry/bid/hsncodes/invoice';
export const BROADCAST_MESSAGE_INQUIRY = '/inquiry/comments/create/bulk';

// Booking Inquiry
export const BOOKING_FETCH_ALL_FF = '/booking/fetchAllBookingForFF';
export const BOOKING_FETCH_ALL_SHIPPER = '/booking/fetchAllBookingForShipper';
export const BOOKING_FETCH_STATUS_WISE_COUNT_FOR_BOOKINGS = '/booking/fetchBookingStatusWiseCount';
export const BOOKING_CREATE = '/booking/create';
export const BOOKING_CONFIRM = '/booking/confirmBooking';
export const BOOKING_DECLINE = '/booking/declineBooking';
export const BOOKING_FETCH_CHARGE_DETAILS = '/booking/getChargeDetails';
export const BOOKING_PENDING_COUNT = '/booking/getPendingBookingCount';
export const BOOKING_FETCH_BOOKING_DETAILS = '/booking/getBookingDetails';
export const BOOKING_BID_BREAKDOWN = '/booking/getChargesBreakdown';
export const BOOKING_SEARCH = '/booking/searchBooking';
export const BOOKING_GET_BOOKING_STAT = '/booking/fetchBookingStatsForInquiry';
export const BOOKING_BID_RANKS_FOR_BOOKING = '/booking/getBidRanksForBooking';
export const FETCH_ALL_BIDS_FOR_BOOKING = '/booking/fetchAllBidsForBooking';
export const EXTRACT_DO_DETAILS = '/booking/extract-do-details';
export const CREATE_INTTRA_BOOKING = '/booking/ff/create-inttra-booking-request';
export const CANCEL_INTTRA_BOOKING_REQUEST = '/booking/ff/cancel-inttra-booking-request';
export const AMEND_INTTRA_BOOKING_REQUEST = '/booking/ff/amend-inttra-booking-request';
export const REQUEST_INTTRA_REGISTRATION_EMAIL =
  '/booking-request/send-request-inttra-registration-code-email';
export const FETCH_LOCATION = '/location/search';
export const CREATE_SPLIT_BOOKINGS = '/booking/split';
export const FETCH_SPLIT_BOOKING_DETAILS = '/booking/fetch-split-bookings';
export const NOTIFY_USERS_BOOKING = '/booking/notify-users';

export const RESEND_USER_INVITE = '/user/resend/invite';

export const BOOKING_MIS_REPORTS = '/booking/fetchBookingReportsDashboard';

// Unified Shipmemt
export const FETCH_ALL_SHIPMENTS = '/shipment/fetch';
export const FETCH_SHIPMENT_DETAILS = '/shipment/details';
export const CREATE_SHIPMENT_OLD = '/shipment-tracking';
export const POLL_SHIPMENTS = '/shipment/poll';
export const DOWNLOAD_SHIPMENT_CONTAINER_TRACKING = '/shipment/download';
export const REFRESH_SHIPMENTS = '/shipment/refresh';
export const DELETE_SHIPMENTS = '/shipment';
export const SHARE_SHIPMENTS = '/shipment/bulk/status/share';
export const GET_CONTAINER_DETAILS_CONTAINER = '/container/fetch/detailed';
export const GET_CONTAINER_DETAILS_UUID_CONTAINER = '/p/cn_detail';
export const SEND_DSR_TRACKING_SHIPMENT_CUSTOMER = '/shipment/send/dsr/customer';
export const SEND_DSR_TRACKING_SHIPMENT_USER = '/shipment/send/dsr/user';
export const SEARCH_SHIPMENT_INVOICE = '/search/invoice';

export const RFQ_DOWNLOAD_SAMPLE_REFERENCE_RATE =
  '/rfq/plan/lineItem/download/referenceRate/excelV2';
// Shipment Execution
export const EXECUTION = '/execution';
export const EXECUTION_NOTIFICATION = '/pigeon/notifications';
export const EXECUTION_NOTIFICATION_POLLING = '/pigeon/notifications/polling';
export const EXECUTION_MIS_REPORTS = '/reports';
export const SHIPPING_SEARCH = '/searchShipmentData';
export const EXECUTION_GET_TASK_SUMMARY = '/getTaskSummaryForShipment';
export const EXECUTION_GET_TASK_COUNT_BY_STATUS = '/getTaskCountByStatusForShipment';
export const EXECUTION_FETCH_D0_DETAILS = (shipmentId) =>
  `/execution/${shipmentId}/delivery-order-execution`;
export const EXECUTION_UPDATE_SHIPMENT = '/edit';
export const EXECUTION_DELETE_SHIPMENT = '/deleteShipments';
export const EXECUTION_SEARCH_BOOKING_ID = '/searchBookingForShipment';
export const EXECUTION_GET_SHIPMENT_FOR_BOOKING = '/getShipmentsForBooking';
export const EXECUTION_CREATE_DO = (shipmentId) =>
  `/execution/${shipmentId}/delivery-order-execution`;
export const EXECUTION_EDIT_DO = (shipmentId, deliveryOrderExecutionId) =>
  `/execution/${shipmentId}/delivery-order-execution/${deliveryOrderExecutionId}`;
export const EXECUTION_GET_FF_FOR_TASK = '/getTaskResponsibleOrganisationMaster';
export const EXECUTION_GET_TASK_TEMPLATES = (id) => `/${id}/task-templates`;
export const EXECUTION_GET_CONTAINER_LIST = '/fetch/tracking/container';
export const EXECUTION_GET_BL_LIST = '/fetch/tracking/tracking-request';
export const EXECUTION_GET_CARGO_LIST = '/fetch/tracking/awb';
export const EXECUTION_ADD_TRACKING = '/tracking/add';
export const EXECUTION_GET_CUSTOM_FIELDS = '/organisation-custom-fields';
export const EXECUTION_SAILING_SCHEDULES = (id) => `/${id}/vessel-schedules-search`;
export const EXECUTION_SELECTED_SCHEDULE = (id, taskId) =>
  `/${id}/task/${taskId}/vessel-schedules-details`;
export const EXECUTION_BOOKING_NOTE_VESSEL_SCHEDULE = (id, taskId) =>
  `/execution/${id}/task/${taskId}/booking-note-vessel-schedules-details`;
export const EXECUTION_BOOKING_NOTE_DETAILS = (id, taskId) =>
  `/execution/${id}/task/${taskId}/approve-booking-note-details`;
export const EXECUTION_GET_DAILY_MIS_REPORT = '/execution/daily-mis-report';
export const EXECUTION_DOWNLOAD_DAILY_MIS_REPORT = '/execution/daily-mis-report/download';
// export const EXECUTION_FETCH_BOOKING_DETAILS = '/execution/bookings';

// execution documents
export const EXECUTION_GET_DOCUMENTS = (id) => `/execution/${id}/documents`;
export const EXECUTION_SHARE_DOCUMENTS = (id) => `/execution/${id}/documents/share`;
export const EXECUTION_GET_DOCUMENTS_MASTERS = (id) => `/execution/${id}/documents/master-data`;
export const EXECUTION_FETCH_BOOKING_DETAILS = '/bookings';
export const EXECUTION_FETCH_SHIPMENT_INSTRUCTIONS = '/execution/shipping-instructions/fetch';
export const EXECUTION_FETCH_SI_DRAFT_DETAILS = '/execution/shipping-instructions/draft';
export const EXECUTION_FETCH_SI_DETAILS = '/execution/shipping-instructions';
export const EXECUTION_SAVE_SI_DRAFT = '/execution/shipping-instructions/save-draft';
export const EXECUTION_SAVE_SHIPPING_INSTRUCTION = '/execution/shipping-instructions/save';
export const EXECUTION_FETCH_SI_PACKAGE_TYPES = '/execution/shipping-instructions/product-type';
export const EXECUTION_FETCH_SI_CONTAINERS = '/execution/shipping-instructions-containers';
export const EXECUTION_SI_FETCH_PARTIES_INVOLVED_ADDRESS = '/execution/shipping-instructions/party-address';
export const EXECUTION_SI_ADD_PARTIES_INVOLVED_ADDRESS = '/execution/shipping-instructions/party-address';
export const EXECUTION_SI_FETCH_CONTAINER_DETAILS = '/execution/shipping-instructions/containers';
export const EXECUTION_SI_FETCH_PENDING_COUNT = '/execution/task-request/container-count';
export const EXECUTION_DELETE_SI_REQUEST = '/execution/shipping-instructions';
export const EXECUTION_AMEND_SI_REQUEST = '/execution/shipping-instructions/amend';
export const EXECUTION_RETRY_SI_REQUEST = '/execution/shipping-instructions/retry';
export const EXECUTION_VGM = '/execution/vgm';
export const EXECUTION_VGM_METHOD_REQUEST = '/valuation-method-request-history';
export const EXECUTION_VGM_FETCH_AUTHORISED_PERSONS = '/authorised-users';
export const EXECUTION_VGM_SAVE_REQUEST = '/add';
export const EXECUTION_VGM_SAVE_DRAFT_REQUEST = '/save-draft';
export const EXECUTION_VGM_FETCH_DRAFT = '/draft';
export const EXECUTION_VGM_GET_THIRD_PARTY_AUTH_LETTER = '/third-party/auth-letter';
export const EXECUTION_VGM_ADD_THIRD_PARTY_AUTH_LETTER = '/shipper/auth-letter';
export const EXECUTION_FETCH_VGM_REQUESTS = '/requests';
export const EXECUTION_FETCH_VGM_DETAILS = '/request';
export const EXECUTION_FETCH_VGM_REQUEST_STATUS = '/request-status';
export const EXECUTION_RETRY_VGM_REQUEST = '/retry';
export const EXECUTION_VGM_FETCH_USER_ASSIGNEE = '/user-assignee';
export const EXECUTION_FORM_13 = '/execution/form13';
export const EXECUTION_FORM_13_REQUEST_ODEX_REF_NUMBER = '/request-odex-reference-number';
export const EXECUTION_FORM_13_FETCH_VESSEL_MASTERS = '/vessel-masters';
export const EXECUTION_FORM_13_FETCH_POD_MASTERS = '/pod-masters';
export const EXECUTION_FORM_13_FETCH_CFS = '/cfs-search';
export const EXECUTION_FORM_13_FETCH_PENDING_CONTAINERS = '/pending-containers';
export const EXECUTION_FORM_13_SAVE_DRAFT = '/save-draft';
export const EXECUTION_FORM_13_FETCH_REQUESTS = '/requests';
export const EXECUTION_FORM_13_FETCH_REQUEST = '/request';
export const EXECUTION_FORM_13_FETCH_ORG_ASSIGNEE = '/org-assignee';
export const EXECUTION_GET_COURIER_TRACKING = (id) => `/execution/${id}/courier-tracking`;
export const EXECUTION_GET_COURIER_V2_TRACKING = (id) => `/courier-v2/fetch/${id}`;
export const EXECUTION_GET_COURIER_V2_VENDORS = () => `/courier-v2/partners`
export const EXECUTION_POST_ADD_COURIER_V2 = () => `/courier-v2/add`


export const EXECUTION_TASK = '/task';
export const EXECUTION_BULK_TASK = '/task/bulk';
export const EXECUTION_COMPUTE_DEADLINES = '/dependent-tasks/deadline';

export const EXECUTION_ACTIVITY = '/activity';
export const EXECUTION_FETCH_ALL_ACTIVITIES = '/fetch';
export const EXECUTION_GET_BOE_DETAILS = (id) => `/execution/${id}/bill-of-entry`;
export const EXECUTION_EDIT_SHIPMENT_WATCHER = (id) => `/execution/${id}/watcher`;

export const EXECUTION_GET_EDIT_TASK_DETAILS = (id, taskId) =>
  `/execution/${id}/task/${taskId}/details`;
export const EXECUTION_DUPLICATE_TASK_DETAILS_FIELD = (id, taskId, fieldId) =>
  `/execution/${id}/task/${taskId}/field/${fieldId}/duplicate`;
export const EXECUTION_DELETE_TASK_DETAILS_FIELD = (id, taskId, fieldId) =>
  `/execution/${id}/task/${taskId}/field/${fieldId}`;

export const GET_EXECUTION_PORTS = (id: string) => `/execution/${id}/port-search`;
export const GET_EXECUTION_DROPDOWN_MASTER = (id: string) => `/execution/${id}/dropdown-master`;
export const GET_EXECUTION_CUSTOM_FIELD_DROPDOWN = (id: string) => `/execution/${id}/custom-field-dropdown`;

export const GET_SHIPMENT_PIC_DETAILS = (id: string) => `/shipment-pic/${id}`;
export const UPDATE_SHIPMENT_PIC_DETAILS = '/shipment-pic';

export const EXECUTION_DOWNLOAD_SAMPLE_FILE = '/execution/bulk/download/sample';
export const EXECUTION_BULK_SHIPMENT = '/execution/bulk';

export const GET_SHIPMENT_CONTAINERS = (referenceNumber: string) => `/execution/containers/${referenceNumber}`; 
export const EXECUTION_DELINK_CONTAINERS = `/execution/delink-containers`;
export const BULK_UPDATE_DOWNLOAD_SAMPLE_FILE = '/execution/container-task/excel';
export const FETCH_USER_FORM_FIRLD_CONFIG = '/custom-configuration/fetch-user-form-field-config';
export const FETCH_USER_FORM_FIRLD_MASTER = '/custom-configuration/fetch-user-form-field-master';
export const FETCH_MY_TASK_NAME_LIST = '/execution/task/name-list';

// Organisation Profiling
export const ORG_PROFILING_GET_MASTER = '/orgconfig/fetchMasterData';
export const ORG_PROFILING_FETCH_ORG_DETAILS = '/orgconfig/fetchOrganisationDetails';
export const ORG_PROFILING_UPDATE_PROFILE = '/orgconfig/createOrUpdateOrganisationProfile';
export const ORG_PROFILING_FETCH_ORG_PROFILE_DETAILS = '/orgconfig/fetchOrganisationProfile';
export const ORG_CONFIG_CONSIGNOR_ADDRESS = '/orgconfig/consignor-address';
export const ORG_CONFIG_CONSIGNOR_ADDRESS_PAGINATED = '/orgconfig/consignor-address/paginated';
export const ORG_CONFIG_DISTANCE_BETWEEN_ADDRESSES = '/orgconfig/distance-between-consignor-addresses'
export const ORG_CURRENCY = '/country';
export const ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_SAMPLE_EXCEL = '/orgconfig/consignor-address/sampleBulk/download';
export const ORG_CONFIG_CONSIGNOR_ADRESS_UPLOAD_EXCEL = '/orgconfig/bulkConsignorAddressUpload';
export const ORG_CONFIG_CONSIGNOR_ADRESS_UPDATE_EXCEL = '/orgconfig/bulkConsignorAddressUpdate';
export const ORG_CONFIG_DELETE_CONSIGNOR_ADDRESS = '/orgconfig/consignor-address';
export const ORG_CONFIG_ENABLE_CONSIGNOR_ADDRESS = (id: string) => `/orgconfig/consignor-address/${id}/enable`;

// Tasks
export const TASKS_ADD_DOCUMENT_TO_TASK = (shipmentId, taskId) =>
  `/execution/${shipmentId}/task/${taskId}/documents`;

// Manual Container Tracking
export const GET_MANUAL_TRACKING_MASTER = '/shipment/manual-tracking/master-data';
export const GET_LAST_ACTIVITY_TRACKING_EVENT = '/shipment/last/event';
export const ADD_MANUAL_TRACKING_EVENT = '/container/tracking/manual';

export const VIEW_BREAKDOWN_DOWNLOAD = '/inquiry/bid/getViewBreakdownPdf';

// invoice APIs
export const INVOICE_USERS = (invoiceId) => `/invoicev2/${invoiceId}/taggableUsers`;
export const INVOICE_DISPUTE = '/dispute';
export const INVOICE_PAYMENT = (invoiceId) => `/invoicev2/${invoiceId}/payment`;
export const INVOICE_STATUS = '/status';
export const INVOICE_APPROVE = (invoiceId) => `/invoicev2/${invoiceId}/approve`;
export const INVOICE_RAISE_DISPUTE = (invoiceId) => `/invoicev2/${invoiceId}/dispute`;
export const INVOICE_RESOLVE_DISPUTE = (invoiceId) => `/invoicev2/${invoiceId}/dispute/resolve`;
export const INVOICE_SETTLE = (invoiceId) => `/invoicev2/${invoiceId}/settle`;
export const INVOICE_DELETE = (invoiceId) => `/invoicev2/${invoiceId}/delete`;
// export const INVOICE = '/invoice';
export const INVOICE = '/invoice';
export const INVOICE_CREATE = '/invoicev2';
export const INVOICE_GET_DETAILS = (invoiceId) => `/invoicev2/${invoiceId}`;
export const INVOICE_ALL = '/invoicev2/all'
export const INVOICE_FETCH_MASTER_DATA = '/masterdata';
export const INVOICE_RESOLVE = '/resolve';
export const INVOICE_SEARCH = '/invoicev2/search';
export const INVOICE_ACTIVITY_FETCH = '/invoicev2/event/all';
export const INVOICE_FETCH_COUNTS = '/invoicev2/statusCount';
export const INVOICE_BALANCE = '/amount';
export const INVOICE_SHIPMENT = '/execution/reference-details-for-invoice';
export const INVOICE_BOOKING = '/booking/booking-details-for-invoice';
export const INVOICE_DOWNLOAD = '/download';
export const INVOICE_REPORTS = '/reports';
export const INVOICE_REPORTS_DOWNLOAD = '/invoicev2/all/download';
export const INVOICE_AGEING_VIEW_REPORTS_DOWNLOAD = '/invoicev2/agingView/download';
export const INVOICE_PAYMENT_DOWNLOAD = '/invoicev2/download-vendor-payment';
export const INVOICE_AGEING_VIEW_REPORTS = '/invoicev2/agingView';
export const INVOICE_SEARCH_SHIPMENT = '/execution/searchShipment/invoice';
export const INVOICE_SHIPMENT_BOOKING_META_REPORT = '/invoicev2/invoiceShipmentBookingReport';
export const INVOICE_IMPORT_SET = '/invoicev2/import-set-list';
export const INVOICE_DOWNLOAD_VENDOR_PAYMENT = '/invoicev2/download-vendor-payment';
export const INVOICE_HISTORICAL_EXCHANGE_RATE = '/currency-exchange/fetch/historical-exchange-rates';

export const ARCHIVE_SHIPMENT = '/shipment/archive';
export const UNARCHIVE_SHIPMENT = '/shipment/unarchive';
export const GET_SHIPPERS = '/master/fetch/master/linkedShippers';
export const FETCH_LINKED_FFS = '/master/fetch/linkedFFs';
export const GET_LINKED_SHIPPERS = '/inquiry/shippers';
export const GET_CHARGES_LIST = '/inquiry/bid/charges/invoice'

// Teams
export const FETCH_ALL_TEAM = '/team/relation/teams';
export const SEARCH_TEAM = '/teams/search';
export const ADD_TEAM = '/teams';
export const SEARCH_TEAM_MEMBERS = '/team/relation/users/search';
export const SEARCH_USER= '/team/relation/users/all/search';
export const DELETE_USER_FROM_TEAM = '/team/relation/users';
export const FETCH_ALL_USERS_IN_TEAM = '/team/relation/teams';
export const FETCH_USER_TEAMS = '/team/relation/user-teams'

export const ADD_MEMBERS = '/team/relation';

export const DOWNLOAD_SAMPLE_INQUIRY = '/inquiry/sampleBulk/download';
export const BULK_INQUIRY_CREATION_ENDPOINT = '/inquiry/createInquiryBulk{mode}';
export const FETCH_LINKED_FFS_FOR_INQUIRY = '/inquiry/bid/fetch/linkedFFsForInquiry';
export const CREATE_ORGANISATION_GROUP = '/master/createOrganisationGroup';
export const FETCH_ORGANISATION_FF_GROUPS = '/master/fetchOrganisationGroups';
export const VALIDATE_FF_GROUP_NAME = '/master/validateIfOrganisationGroupExists';
export const ASSIGN_GROUP_TO_ORGANISATION = '/master/assignGroupsToOrganisation';
export const ADD_SPOC = '/stakeholder/spoc';
export const UPDATE_VENDOR_INFORMATION = '/master/updateVendorDetails';

// Country
export const SEARCH_COUNTRY = '/country/search';
export const ALL_COUNTRY = '/country';
export const GET_SWAGGER_JSON_DATA = '/api-spec';

// rate master
export const RATE_DIGITISATION = '/rate-digitisation';
export const RATE_DIGITISATION_FETCH_ALL_RATES = '/fetch-rates';
export const RATE_DIGITISATION_ADD_SINGLE_RATE = '/add-single-rate';
export const RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_ADD = '/download-sample-excel-file/add';
export const RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_EDIT = '/download-sample-excel-file/edit';
export const RATE_DIGITISATION_CREATE_BULK_REQUEST_ADD = '/create-bulk-request/add';
export const RATE_DIGITISATION_BULK_REQUEST_EDIT = '/create-bulk-request/edit';
export const RATE_DIGITISATION_UPDATE_SINGLE_RATE = '/update-single-rate';
export const RATE_DIGITISATION_MASTER = '/master';
export const RATE_DIGITISATION_DELETE_RATES = '/delete-rates';
export const RATE_DIGITISATION_DOWNLOAD_RATES = '/download-results-excel';
export const RATE_DIGITISATION_DISCOVER_RATES_SEARCH = '/discover-rates/buy/search';
export const RATE_DIGITISATION_DISCOVER_RATES_GET_FILTERS = '/discover-rates/get-filters';
export const DISCOVER_RATES_BUY_REPORT_ISSUE = '/discover-rates/buy/report-issue';
export const DISCOVER_RATES_SELL_REPORT_ISSUE = '/discover-rates/sell/report-issue';
export const DISCOVER_RATES_FETCH_SELL_RATES = '/discover-rates/sell/search';
export const DISCOVER_RATES_SAVE_GRID_SEARCH_HISTORY = '/discover-rates/save-grid-search-history';
export const DISCOVER_RATES_FETCH_RECENT_SEARCHES = '/discover-rates/recent-searches/fetch';
export const DISCOVER_RATES_FETCH_TRENDING_SEARCHES = '/discover-rates/trending-searches/fetch';
export const DISCOVER_RATES_FETCH_SEARCH_BAR_FILTERS = '/discover-rates/get-search-filters';
//Share Rate
export const DISCOVER_RATES = '/discover-rates';
export const DOWNLOAD_QUOTATION_PDF = '/download-pdf';
export const DISCOVER_RATES_SEND_EMAIL = '/sharing-module/share';
export const FETCH_SHARED_DATA = '/sharing-module';

/**
 * Comments
 */
export type CommentApiPrefix = 'inquiry' | 'execution' | 'invoice' | 'booking' | 'inquiry/bid';
export const getCommentFetchAllRoute = (
  commentApiPrefix: CommentApiPrefix,
  sourceObjectId: string
) => {
  if (commentApiPrefix === 'invoice') {
    return `/invoicev2/${sourceObjectId}/comments`;
  }
  return `/${commentApiPrefix}/${sourceObjectId}/comments`;
};
export const getCommentPostRoute = (commentApiPrefix: CommentApiPrefix, sourceObjectId: string) => {
  if (commentApiPrefix === 'invoice') {
    return `/invoicev2/${sourceObjectId}/comment`;
  }
  return `/${commentApiPrefix}/${sourceObjectId}/comments/create`;
};
export const getFetchTaggableUsersRoute = (
  commentApiPrefix: CommentApiPrefix,
  sourceObjectId: string
) => {
  return `/${commentApiPrefix}/${sourceObjectId}/fetchTaggableUsers`;
};
export const getCommentCountRoute = (
  commentApiPrefix: CommentApiPrefix,
  sourceObjectId: string
) => {
  if (commentApiPrefix === 'invoice') {
    return `/invoicev2/${sourceObjectId}/comments/count`;
  }
  return `/${commentApiPrefix}/${sourceObjectId}/comments/count`;
};

export const GET_RFQ_COMMENTS = '/rfq/plan/remarks';
// reference rates
export const RESET_REFERENCE_RATE_NOTIFICATION_ROUTE = '/inquiry/disableNotificationFlag';
export const EDIT_REFERENCE_RATES_ROUTE = '/inquiry/edit/referenceRate';
export const FETCH_LOWEST_BID_ROUTE = '/inquiry/bid/fetchL1BidForInquiry';
export const FETCH_AMENDMENT_VERSION_NAMES = '/rfq/plan/amendment/versionNames';
export const RFQ_SHIPPINGLINE_PLAN = '/rfq/shippingLine/plan';

// bulk request
export const FETCH_BULK_REQUESTS = '/rate-digitisation/fetch-bulk-requests';
export const DOWNLOAD_BULK_REQUESTS = '​/rate-digitisation/download-bulk-requests';

// DSR templates
export const DSR_TEMPLATE = '/excel-template';
export const DSR_HEADERS = '/headers/grouped';
export const DSR_TEMPLATE_SEARCH = '/excel-template/search';

//Port Groups
export const ALL_PORT_GROUPS = '/port-groups/getAll'
export const CREATE_PORT_GROUP = '/port-groups/create'
export const GET_PORT_GROUP = (id: string) => `/port-groups/${id}`
export const UPDATE_PORT_GROUP = (id: string) => `/port-groups/update/${id}`
export const UPDATE_PORT_GROUP_STATUS = (id:string) => `/port-groups/update/status/${id}`

// Markup Automation Tool
export const MARKUP_CRITERIA = '/markup-criteria';
export const MARKUP_FETCH_CRITERIA = '/fetch';
export const MARKUP_DUPLICATE = '/duplicate';
export const MARKUP_FETCH_ONE = '/fetch-one';
export const MARKUP_DELETE = '/delete';
export const MARKUP_DOWNLOAD_SAMPLE_FILE = '/rules/download-sample-file';
export const MARKUP_ADD_CRITERIA = '/add';
export const MARKUP_EDIT_CRITERIA = '/edit';

// kyc connections
export const FETCH_KYC = '/kyc/fetch/negotiation';
export const CREATE_BOOKING_DATA = '/inquiry/negotiation/create-booking-data';
// Product

export const PRODUCT = '/product';
export const PRODUCT_SEARCH = '/product/search';
export const PRODUCT_PAGINATION = '/product/paginated'
export const PRODUCT_MASTER_SEARCH = '/product/master/search';
export const PRODUCT_BULK_UPLOAD = '/product/bulk';
export const PRODUCT_BULK_UPDATE = '/product/bulk/update';
export const PRODUCT_MASTER_BULK_UPLOAD = '/product/bulk/productMaster';
export const PRODUCT_BULK_SAMPLE_DOWNLOAD = '/product/bulk/download/sample';
export const PRODUCT_DOWNLOAD_RESULTS = '/product/download-results-excel';
export const PRODUCT_MASTER_BULK_SAMPLE_DOWNLOAD = '/product/bulk/master/download/sample'

// Customer
export const CUSTOMER_BULK_UPLOAD = '/stakeholder/create/bulk/by-excel';
export const CUSTOMER_BULK_SAMPLE_DOWNLOAD = '/stakeholder/bulk/download/sample';

// Vessel Schedules
export const FETCH_VESSELS = '/vessel-schedules/search';
// Platform
export const FETCH_ORGANISATION_DETAILS = '/orgconfig/fetchOrganisationDetails';

// EMail And Notifications
export const USER_NOTIFICATION_PREFERENCES = '/user/notification/preference';
// Organisation Config
export const FETCH_AUTH_SETTINGS = '/orgconfig/auth-settings';
export const GET_INVOICE_ORG_SETTINGS = (toOrganisationId) => `/invoicev2/invoiceSettings/${toOrganisationId}`;

export const ACCEPT_PRIVACY_POLICY = '/user/accept-agreement';

export const COURIER_PARTNER = '/courier/partners';
export const ENTRY_PORT = '/entry-port';
//Air Cargo
export const AIR_CARGO_FETCH_ALL = '/awb/fetch';
export const FREIGH_FORWARDED_FETCH_ALL = '/hawb/fetch';
export const AIR_CARGO_SEARCH = '/awb/search';
export const FREIGH_FORWARDED_SEARCH = '/hawb/search';
export const FREIGH_FORWARDED_DOWNLOAD_SAMPLE = '/hawb/download/sample';
export const AIR_CARGO_DOWNLOAD_SAMPLE = '/awb/download/sample';
export const AIR_CARGO_GET_STATUS = '/awb/status';
export const FREIGH_FORWARDED_GET_STATUS = '/hawb/status';
export const FREIGH_FORWARDED_REFRSH = '/hawb/refresh';
export const AIR_CARGO_REFRSH = '/awb/refresh';
export const FREIGH_FORWARDED_HAWB_ANALYTICS_REPORT = '/hawb/reports';
export const FREIGHT_FORWARDED_HAWB_RECENT_FILTERS = '/hawb/recent/filters/history';
export const AIR_CARGO_INTERNAL_REFERENCE_NUMBERS_SEARCH = '/hawb/search/internalreferencenumber';

// Container Triagulation
export const CONTAINER_TRIANGULATION_ONBOARD = '/triangulation/permission';
export const CONTAINER_TRIANGULATION_FETCH_IMPORTER_SETTINGS = '/triangulation/organisations';
export const CLAIMED_CONTAINERS = '/triangulation/claimed/containers';
export const CLAIM_CONTAINERS = '/triangulation/claim';
export const TRIANGULATION_FETCH = '/triangulation/fetch';
export const TRIANGULATION_STATUS_COUNT = '/triangulation/status';
export const TRIANGULATION_CLAIMS = '/triangulation/claims';
export const WEBHOOK = '/webhook';
export const WEBHOOK_EVENTS = '/webhook/events'
//Vessel Tracking
export const GET_VESSEL_TRACKING = '/vessel/tracking';

// Payment
export const GET_CURRENT_SUBSCRIPTION = '/payment/subscription';
export const UPDATE_SUBSCRIPTION_PLAN = '/payment/subscription';
export const GET_BILLING_ADDRESS = '/payment/billing-address';
export const GET_TAX_INVOICES = '/payment/invoices';
export const UPDATE_BILLING_ADDRESS = '/payment/billing-address';
export const PAYMENT_DETAILS = '/payment/details';
export const PAYMENT_DETAILS_USING_INTENT = '/payment/details/using-intent';
export const DOWNLOAD_TAX_INVOICE = (id) => `/payment/invoice/${id}/download`;
export const GET_PLAN_HISTORY = '/payment/plan-history';
export const PAYMENT_INTENT = '/payment/intent';

// Subscription
export const GET_SUBSCRIPTION_DETAILS = '/subscription';


export const CUSTOM_CONFIGURATION = '/custom-configuration';
export const BUSINESS_UNIT = '/business-unit';

export const  DOWNLOAD_DUMP_HAWB = '/hawb/download';
export const DOWNLOAD_DUMP_AWB = '/awb/download'

// Demurrage And Detention
export const FETCH_DND_CONFIGURATION = '/dnd-configuration';
export const FETCH_DND_MAPPINGS = '/mapping';
export const DOWNLOAD_DND_MAPPINGS = '/download';

// Tasks Workflow
export const FETCH_TASK_WORKFLOW_TEMPLATES = '/execution-workflow/templates';
export const FETCH_WORKFLOW_MILESTONES_DROPDOWN = '/tasks/visible-to-dropdown'
export const WORKFLOW_TASK_VISIBILITY = '/tasks';
export const FETCH_WORKFLOW_PERMISSIONS_DATA = `/tasks/permission-config`;
export const UPDATE_WORKFLOW_VISIBILITY_PERMISSIONS = '/tasks/permission-config';
export const UPDATE_WORKFLOW_AUTOMATION_CONFIG = '/tasks/update-workflow-automation';


// Masters Document
export const DOCUMENT_MASTER_FETCH = '/document-master/fetch';
export const DOCUMENT_MASTER_CREATE = '/document-master/create';
export const DOCUMENT_MASTER_UPDATE = '/document-master/update';
export const DOCUMENT_MASTER_DELETE = '/document-master/delete';

// Approval Policies
export const APPROVAL_POLICIES = '/approval-config/policies';
export const APPROVAL_FIELDS = '/approval-config/fields';

// Approval Engine (runtime approve/reject + inbox)
export const APPROVAL_REQUESTS = '/approval-requests';
